import { useAppSelector } from "./store";
import "./PhaseBox.css";
import { PhaseType } from "./common/Info";

function PhaseBox() {
  const phase = useAppSelector((state) => {
    return state.game.phase;
  });
  const players = useAppSelector((state) => {
    return state.players;
  });
  const user = useAppSelector((state) => {
    return state.profile;
  });
  const game = useAppSelector((state) => {
    return state.game;
  });

  const currentTurnPlayer = players[game.currentPlayerIndex];

  const userIndex = players.findIndex((obj) => obj.id === user.id);
  const player = players[userIndex];
  const isUsersTurn = userIndex === game.currentPlayerIndex;

  let text: string;

  if (players.length === 0) {
    text = "";
  } else {
    switch (phase) {
      case PhaseType.dice:
        if (isUsersTurn) {
          text = "Waiting for you to roll the dice";
        } else {
          text = `Waiting for ${currentTurnPlayer.name} to roll the dice`;
        }
        break;
      case PhaseType.white:
        const playerNames = players
          .filter((p) => !p.whiteDicePhaseActionTaken)
          .map((p) => p.name);
        const nameString = playerNames.join(", ").trim();
        const youString = nameString.replace(user.name, "you");
        text = `Waiting for ${youString} to mark a box with the white dice or pass`;
        break;
      case PhaseType.color:
        if (isUsersTurn) {
          if (player.whiteDicePhaseBoxMarked) {
            text = "Waiting for you to mark a box with the color dice or pass";
          } else {
            text = "Waiting for you to mark a box with the color dice";
          }
        } else {
          text = `Waiting for ${currentTurnPlayer.name} to mark a box with the color dice or pass`;
        }
        break;
      case undefined:
        text = "";
        break;
      default:
        text = "";
        console.log(`Invalid phase ${phase}`);
    }
  }
  return (
    <div className="phaseBox centerContainer">
      <div className="phaseContainer">{text}</div>
    </div>
  );
}

export default PhaseBox;
